<template>
  <div class="pageContent">
    <!-- 新县好礼 -->
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>新县好礼</h4>
        <span @click="goList('乡土民情', '新县好礼')">更多>></span>
      </div>
      <div class="item-list">
        <ul>
          <li
            v-for="(item, index) in giftDataList"
            :key="index"
            @click="goDetail('新县好礼', item)"
          >
            <img :src="imgURl + 'xxszxc/' + item.slt" />
            <div class="item-context">
              <p>{{ item.bt }}</p>
              <p class="txt">{{ item.pubDesc }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 节庆活动-->
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>节庆活动</h4>
        <span @click="goList('乡土民情', '节庆活动')">更多>></span>
      </div>
      <div class="item-list">
        <ul>
          <li
            class="width25"
            v-for="(item, index) in hdDataList"
            :key="index"
            @click="goDetail('节庆活动', item)"
          >
            <img :src="imgURl + 'xxszxc/' + item.slt" />
            <div class="item-context">
              <p>{{ item.bt }}</p>
              <p>
                {{ item.pubDesc }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 特色美食 -->
    <div class="lc-list width-1200">
      <div class="item-title">
        <h4>特色美食</h4>
        <span @click="goList('乡土民情', '特色美食')">更多>></span>
      </div>
      <div class="item-list">
        <ul>
          <li
            v-for="(item, index) in foodDataList"
            :key="index"
            @click="goDetail('特色美食', item)"
          >
            <img :src="imgURl + 'xxszxc/' + item.slt" />
            <div class="item-context">
              <p>{{ item.bt }}</p>
              <p>
                {{ item.pubDesc }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const imgURl = API_IMG_URL;
export default {
  data() {
    return {
      imgURl: imgURl,
      hdDataList: [],
      giftDataList: [],
      foodDataList: [],
    };
  },
  components: {},
  methods: {
    goList(meunname, type) {
      this.$router.push({
        path: "list",
        query: {
          meunname: meunname,
          type: type,
        },
      });
    },
    goDetail(type, item) {
      this.$router.push({
        path: "detail",
        query: {
          type: type,
          title: item.pubTittle,
          id: item.id,
        },
      });
    },
    async getDataList(params) {
      let res = await this.$http.queryPageList(params);
      // pubType 41-新县好礼,42-节庆活动,43-特色美食
      if (params.pubType == 41) {
        this.giftDataList = res.response.records;
      } else if (params.pubType == 42) {
        this.hdDataList = res.response.records;
      } else if (params.pubType == 43) {
        this.foodDataList = res.response.records;
      }
    },
    initData() {
      let params1 = {
        currentPage: 1,
        pubType: 41,
        pageSize: 3,
      };
      this.getDataList(params1);
      let params2 = {
        currentPage: 1,
        pubType: 42,
        pageSize: 4,
      };
      this.getDataList(params2);
      let params3 = {
        currentPage: 1,
        pubType: 43,
        pageSize: 3,
      };
      this.getDataList(params3);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped>
</style>
